import { useEffect, useState } from 'react';
import { extApi } from '../api/extensibilityClient';

export function ProjectionControlPage({ onChange }: { onChange?: () => void }) {
  const [data, setData] = useState<any>(null);

  const load = () => extApi.projectionControls().then(setData).catch(console.error);
  useEffect(() => { load(); }, []);

  const toggle = async (id: string, enabled: boolean) => {
    await extApi.toggleProjection(id, enabled);
    onChange?.();
    load();
  };

  const preset = async (p: string) => {
    await extApi.applyPreset(p);
    onChange?.();
    load();
  };

  if (!data) return <div className="loading">Loading projection controls…</div>;

  return (
    <div>
      <h1 className="page-title">Projection Control Panel</h1>
      <p className="page-subtitle">Custom Case only — toggle which indicators participate in live GDP recalculation.</p>

      <div className="card" style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
        {['all', 'gdp_drivers_only', 'exports_package', 'industry_package', 'fiscal_package', 'infrastructure_package'].map((p) => (
          <button key={p} className={`btn ${data.preset === p ? '' : 'secondary'}`} type="button" onClick={() => preset(p)}>
            {p.replace(/_/g, ' ')}
          </button>
        ))}
        <button className="btn secondary" type="button" onClick={() => extApi.resetProjection().then(load)}>Clear selection</button>
      </div>

      <div className="card">
        <table className="data-table">
          <thead><tr><th>On</th><th>Variable</th><th>Policy area</th></tr></thead>
          <tbody>
            {data.variables.map((v: any) => (
              <tr key={v.id}>
                <td>
                  <input type="checkbox" checked={v.enabled} onChange={(e) => toggle(v.id, e.target.checked)} />
                </td>
                <td>{v.name}</td>
                <td>{v.policy_area_name}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
